export default __webpack_public_path__ + "station-defect-temperature-gray.png?ffa7fa9637053a31a07c4428c8462e01";